import { PROVIDERS_MAP } from 'common/constants/constants';

export const MigeratioStaleEmptyState = () => {
  return (
    <div className='flex items-center justify-center'>
      <div className='flex flex-row mt-10 bg-slate-50 p-8 gap-4'>
        <div className='flex items-center justify-center'>
          <img
            src={PROVIDERS_MAP.jira.logo}
            alt='Jira logo'
            className='h-20 w-20'
          />
        </div>
        <div className='flex flex-col'>
          <span className='text-2xl font-medium'>
            The Jira integration is inaccessible
            <br />
            due to an ongoing system migration.
          </span>
          <span className='text-sm font-light'>
            We're working to restore access as soon as possible.
            <br />
            For further details, please contact your system administrator.
          </span>
        </div>
      </div>
    </div>
  );
};
